import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import Layout from './components/Layout';
import Dashboard from './pages/Dashboard';
import Profile from './pages/Profile';
import CustomerManagement from './pages/CustomerManagement';
import RateMaster from './pages/RateMaster';
import BookingEntry from './pages/BookingEntry';
import MultipleBooking from './pages/MultipleBooking';
import MultipleBookingView from './pages/MultipleBookingView';
import BookingModify from './pages/BookingModify';
import ViewBookings from './pages/ViewBookings';
import BulkModify from './pages/BulkModify';
import InvoiceGenerator from './pages/InvoiceGenerator';
import NonGstInvoiceGenerator from './pages/NonGstInvoiceGenerator';
import ViewInvoices from './pages/ViewInvoices';
import ViewNonGstInvoices from './pages/ViewNonGstInvoices';
import PaymentPage from './pages/PaymentPage';
import PaymentDetails from './pages/PaymentDetails';
import ExpenseTracker from './pages/ExpenseTracker';
import CreditorsReport from './pages/CreditorsReport';
import DataManagement from './pages/DataManagement';
import CustomerSupport from './pages/CustomerSupport';
import DownloadInvoice from './pages/DownloadInvoice';
import Login from './pages/Login';
import Signup from './pages/Signup';
import UpdatePassword from './pages/UpdatePassword';
import Home from './pages/Home';
import StationaryPurchase from './pages/StationaryPurchase';
import StationarySales from './pages/StationarySales';
import StationaryView from './pages/StationaryView';
import ProtectedRoute from './utils/ProtectedRoute';
import { AuthProvider } from './utils/AuthContext';

function App() {
  return (
    <Router>
      <AuthProvider>
        <div className="App">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/update-password" element={<UpdatePassword />} />
            <Route element={<ProtectedRoute />}>
              <Route element={<Layout />}>
                {/* Removed duplicate '/' route for Dashboard. Use '/dashboard' only. */}
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/profile" element={<Profile />} />
                <Route path="/rates" element={<RateMaster />} />
                <Route path="/customers" element={<CustomerManagement />} />
                <Route path="/booking" element={<BookingEntry />} />
                <Route path="/booking/multiple" element={<MultipleBooking />} />
                <Route path="/booking/multiple/view" element={<MultipleBookingView />} />
                <Route path="/booking/modify" element={<BookingModify />} />
                <Route path="/booking/view" element={<ViewBookings />} />
                <Route path="/booking/bulk-modify" element={<BulkModify />} />
                <Route path="/invoice-generator" element={<InvoiceGenerator />} />
                <Route path="/invoice-generator-non-gst" element={<NonGstInvoiceGenerator />} />
                <Route path="/invoices" element={<ViewInvoices />} />
                <Route path="/invoices-non-gst" element={<ViewNonGstInvoices />} />
                <Route path="/payments" element={<PaymentPage />} />
                <Route path="/payment-details" element={<PaymentDetails />} />
                <Route path="/payment/expenses" element={<ExpenseTracker />} />
                <Route path="/creditors-report" element={<CreditorsReport />} />
                <Route path="/data-management" element={<DataManagement />} />
                <Route path="/support" element={<CustomerSupport />} />
                <Route path="/invoices/download" element={<DownloadInvoice />} />
                <Route path="/stationary/purchase" element={<StationaryPurchase />} />
                <Route path="/stationary/sales" element={<StationarySales />} />
                <Route path="/stationary/view" element={<StationaryView />} />
              </Route>
            </Route>
          </Routes>
          <ToastContainer
            position="top-right"
            autoClose={3000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
          />
        </div>
      </AuthProvider>
    </Router>
  );
}

export default App;